export const createAddresses = (responseAddresses, countries, cantons, phoneFormatter) => {
    return responseAddresses.map((responseAddress) => {
        const country = countries.find((country) => country.id === responseAddress.country.id);
        const canton = cantons.find((canton) => canton.id === responseAddress.state?.id);
        return new Address(
            responseAddress.id,
            responseAddress.is_main,
            responseAddress.firstname,
            responseAddress.lastname,
            responseAddress.third_party,
            responseAddress.gender,
            responseAddress.use_parent_address,
            responseAddress.label,
            responseAddress.can_be_deleted,
            responseAddress.additional_line,
            responseAddress.street,
            // todo SW-416, fix inconsistent response schema
            responseAddress.street_2 ? responseAddress.street_2 : responseAddress.street2,
            responseAddress.box_number,
            responseAddress.zip,
            responseAddress.city,
            canton,
            country,
            responseAddress.email,
            phoneFormatter.format(responseAddress.phone),
            phoneFormatter.format(responseAddress.mobile),
            responseAddress.website,
            // todo fix typo https://project.sia.ch/web#id=2071&action=155&active_id=64&model=project.task&view_type=form&cids=1&menu_id=
            responseAddress.address_lines
        );
    });
};
export default class Address {
    constructor(
        id,
        domicile,
        firstName,
        lastName,
        department,
        gender,
        useHeadquarters,
        label,
        removable,
        additionalInfo,
        primaryStreetWithNumber,
        secondaryStreetWithNumber,
        postOfficeBox,
        zip,
        location,
        canton,
        country,
        email,
        phone,
        mobile,
        website,
        preformattedLines,
    ) {
        this.id = id;
        this.domicile = domicile;
        this.firstName = firstName;
        this.lastName = lastName;
        this.department = department;
        this.gender = gender;
        this.useHeadquarters = useHeadquarters;
        this.label = label;
        this.removable = removable;
        this.additionalInfo = additionalInfo;
        this.primaryStreetWithNumber = primaryStreetWithNumber;
        this.secondaryStreetWithNumber = secondaryStreetWithNumber;
        this.postOfficeBox = postOfficeBox;
        this.zip = zip;
        this.location = location;
        this.canton = canton;
        this.country = country;
        this.email = email;
        this.phone = phone;
        this.mobile = mobile;
        this.website = website;
        this.preformattedLines = preformattedLines;
    }

    getId() {
        return this.id;
    }

    getFirstName() {
        return this.firstName;
    }

    getLastName() {
        return this.lastName;
    }

    getDepartment() {
        return this.department;
    }

    getGender() {
        return this.gender;
    }

    getUseHeadquarters() {
        return this.useHeadquarters;
    }

    isDomicile() {
        return this.domicile;
    }

    getLabel() {
        return this.label;
    }

    isRemovable() {
        return this.removable;
    }

    getAdditionalInfo() {
        return this.additionalInfo;
    }

    getPrimaryStreetWithNumber() {
        return this.primaryStreetWithNumber;
    }

    getSecondaryStreetWithNumber() {
        return this.secondaryStreetWithNumber;
    }

    getPostOfficeBox() {
        return this.postOfficeBox;
    }

    getZip() {
        return this.zip;
    }

    getLocation() {
        return this.location;
    }

    getCanton() {
        return this.canton;
    }

    getCountry() {
        return this.country;
    }

    getEmail() {
        return this.email;
    }

    getPhone() {
        return this.phone;
    }

    getMobile() {
        return this.mobile;
    }

    getWebsite() {
        return this.website;
    }

    getPreformattedLines() {
        return this.preformattedLines;
    }

}
